import { gql } from '@apollo/client';

const QUERY_AVATARS = gql`
  query AllAvatars {
    avatars(pagination: { limit: 200 }) {
      data {
        id
        attributes {
          name
          media {
            data {
              id
              attributes {
                url
              }
            }
          }
        }
      }
    }
  }
`;
export default QUERY_AVATARS;
